import React, {FC} from 'react';

import {AppPanelId} from '../../libs/shared/core/src/store/panels/panelStateBase';
import {useAppSelector} from '../helpers/appReduxHelpers';
import {getHasSupportChatFeature} from '../store/data/company/companySelectors';
import {HelpChatContainer} from './app/helpChat/helpChatContainer';
import {ErrorReporterContainer} from './errors/errorReporterContainer';
import {OnboardingChat} from './onboarding/chat/onboardingChat';

/*
 * Props.
 */

interface AppChatProps {
  panelId: AppPanelId;
}

/*
 * Component.
 */

export const AppChat: FC<AppChatProps> = (props) => {
  const hasSupportChatFeature = useAppSelector(getHasSupportChatFeature);

  // Render at most one chat widget. Paid support gets priority.
  return (
    <ErrorReporterContainer isTopLevel={false}>
      {hasSupportChatFeature ? <HelpChatContainer panelId={props.panelId} /> : <OnboardingChat />}
    </ErrorReporterContainer>
  );
};
